export default function validateUsername(value: string) {
  const badChars = value.match(/[^a-z0-9_\-.]/gi);
  if (!badChars) { return null; }
  return `The username cannot contain ${badChars.join(', ')}`;
}
